/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as AgeassuranceDefs from './defs.defs.js'

const $nsid = 'app.bsky.ageassurance.getState'

export { $nsid }

/** Returns server-computed Age Assurance state, if available, and any additional metadata needed to compute Age Assurance state client-side. */
const main = l.query(
  $nsid,
  l.params({ countryCode: l.string(), regionCode: l.optional(l.string()) }),
  l.jsonPayload({
    state: l.ref<AgeassuranceDefs.State>((() => AgeassuranceDefs.state) as any),
    metadata: l.ref<AgeassuranceDefs.StateMetadata>(
      (() => AgeassuranceDefs.stateMetadata) as any,
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
